import './mars'
import Cookie from 'browser-cookie'
let cookie = new Cookie()

window.inject_mars = {}

if (window.location.origin.includes('school.vip.com')) {
  window.mars_var = {
    user_id: Number(cookie.get('VipRUID')) || Number(cookie.get('VipRUID_VC')),
    from: '',
    to: ''
  }
} else {
  window.mars_var = {
    user_id: Number(cookie.get('VipRUID')) || Number(cookie.get('VipRUID_VC')),
    from: '',
    to: ''
  }
}
